import CryptoJS from 'crypto-js';
import store from '../redux/store';
import { addShowPoints } from '../redux/slices/currentUserSlice';
import { serverAssets } from './common';
import { Feather } from 'react-feather';
import DOMPurify from 'dompurify';

export function ddmmyyyyToyyyymmdd(date) {
    if(!date) return ""
    const [dd, mm, yyyy] = date.split("-");
    return `${yyyy}-${mm}-${dd}`;
}

export function validatepincode(pin) {
  let regPattern = new RegExp(/^[1-9][0-9]{5}$/);
  return regPattern.test(pin);
}

// export function encrypt(text) {
//     try {
//       const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY_CHIPER);
//       const iv = CryptoJS.enc.Base64.parse(process.env.REACT_APP_SECRET_IV);
//       const encoded = CryptoJS.enc.Utf8.parse(text);
//       const ciphertext = CryptoJS.AES.encrypt(encoded, key, {
//         mode: CryptoJS.mode.CBC,
//         iv: iv,
//       });
//       let lastIndexOfEqual = ciphertext.toString().lastIndexOf("=");
//       return ciphertext.toString().substring(0, lastIndexOfEqual - 1);
//     } catch(err) {
//       // silent
//     }
//   }
const PUBLIC_KEY_PEM = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoPMAb8nHUzRaKskgQ8Ej
0TmC/z+N4mxk3JFUQEEWkaTCBgYl+icO4p85dfd1VI7tBGUOj2uXe4IdfjMExmOP
SgKuKjAxhPtoOjmC3pUI7M7VDCha27wXJjXplbPMbvaukmPYmxTfs7zdgm5vjsq1
b4tXX1G9oLIbnAe/3b2BIXiLC3HPBsrGGrIS4eZgKYFRrZX5S09d0uTwqyTiYm4w
YG3krhIuzK/thIuBog+EgZZcmO9BH5puFxJcgT2o5xS+k1Z/bFUPb9kWWsaBq5ZF
C/Avk4x/jN2bkoySFHIZH7vDTAm+eyRsdRWsMNHxfdGwN/Ssb2tNo4Uyj/6BrZPd
fwIDAQAB
-----END PUBLIC KEY-----`;

export async function encrypt(text) {
    try {
        // const response = await fetch('/public.pem', {
        //     cache: 'no-store',
        // });

        // if (!response.ok) {
        //     throw new Error(
        //         `Failed to fetch public key: ${response.status} ${response.statusText}`
        //     );
        // }

        // const pem = await response.text();
        const pem = PUBLIC_KEY_PEM;

        console.log('Public key response:', JSON.stringify(pem));

        let base64Key = pem
            .replace('-----BEGIN PUBLIC KEY-----', '')
            .replace('-----END PUBLIC KEY-----', '')
            .replace(/\s/g, '');

        console.log('Base64 key length:', base64Key.length);
        console.log('Base64 key:', base64Key);
         // Validate Base64 before calling atob()
        if (!base64Key || !/^[A-Za-z0-9+/]*={0,2}$/.test(base64Key)) {
          base64Key = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAoPMAb8nHUzRaKskgQ8Ej0TmC/z+N4mxk3JFUQEEWkaTCBgYl+icO4p85dfd1VI7tBGUOj2uXe4IdfjMExmOPSgKuKjAxhPtoOjmC3pUI7M7VDCha27wXJjXplbPMbvaukmPYmxTfs7zdgm5vjsq1b4tXX1G9oLIbnAe/3b2BIXiLC3HPBsrGGrIS4eZgKYFRrZX5S09d0uTwqyTiYm4wYG3krhIuzK/thIuBog+EgZZcmO9BH5puFxJcgT2o5xS+k1Z/bFUPb9kWWsaBq5ZFC/Avk4x/jN2bkoySFHIZH7vDTAm+eyRsdRWsMNHxfdGwN/Ssb2tNo4Uyj/6BrZPdfwIDAQAB";
        }

        const binaryString = window.atob(base64Key);
        const keyBytes = Uint8Array.from(
            binaryString,
            char => char.charCodeAt(0)
        );
        const publicKey = await window.crypto.subtle.importKey(
            'spki',
            keyBytes.buffer,
            {
                name: 'RSA-OAEP',
                hash: 'SHA-256',
            },
            false,
            ['encrypt']
        );
        const encodedText = new TextEncoder().encode(text);
        const encrypted = await window.crypto.subtle.encrypt(
            {
                name: 'RSA-OAEP',
            },
            publicKey,
            encodedText
        );
        const encryptedBytes = new Uint8Array(encrypted);
        return window.btoa(
            String.fromCharCode(...encryptedBytes)
        );
    } catch (err) {
        console.error('RSA encryption failed:', err);
        throw err;
    }
}

  // export function decrypt(encryptedText) {
  //   const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_SECRET_KEY_CHIPER);
  //   const iv = CryptoJS.enc.Base64.parse(process.env.REACT_APP_SECRET_IV);
  //   const bytes = CryptoJS.AES.decrypt(encryptedText, key, { mode: CryptoJS.mode.CBC, iv: iv });
  //   const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
  //   return decryptedText;
  // }

  export function isMobileNumberValid(num) {
    let contactPetrn = new RegExp(/^[6-9]\d{9}$/);
    let numS = num + '';

    if (contactPetrn.test(num) && parseInt(numS.charAt(0)) > 5 && numS.length == 10) {
      return true;
    }
    return false
  }

  export function formatNumberWithCommas(str = '') {
    if (str == '0' || !!str) {
      // return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      let new_str=Math.round(Number(str));
      return new_str.toLocaleString('en-IN')+".00";
    }
    return '0.00';
  }

  export function validateDoc(docType, docNum) {
    
    let idRegex = new RegExp();
    if (docType == 'Aadhar') {
      idRegex = new RegExp(/^(\d{12})$/);
    } else if (docType == 'Voter ID') { 
      idRegex = new RegExp(/^[A-Z]{3}[0-9]{6}$/); 
    } else if (docType == 'Driving License') {
      idRegex = new RegExp(
        // /^(([A-Z]{2}[0-9]{2})( )|([A-Z]{2}-[0-9]{2}))((19|20)[0-9][0-9])[0-9]{7}$/,
        /^[A-Z]{2}\d{2}[A-Z0-9]{1,3}\d{4,7}$/i  
      );
    } else if (docType == 'PAN') {
      idRegex = new RegExp(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/);
    }
    return idRegex.test(docNum);
  }

  // New-site registrarion
  export function ValidatePhoneNumber(num, setErr, setVal) {
    let contactPetrn = new RegExp(/^[6-9]\d{9}$/);
    let numS = num + '';

    if (contactPetrn.test(num) && parseInt(numS.charAt(0)) > 5) {
      return true;
    }
    setErr('Invalid mobile number');
    setVal('');
    return false;
  }

  export function validateEmail(num, setErr, setVal) {
    let contactPetrn = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    );
    if (contactPetrn.test(num)) {
      return true;
    }
    setErr('Invalid email');
    setVal('');
    return false;
  }

  export function getMonthName(num) {
    switch (num) {
      case 1:
        return 'Jan';
      case 2:
        return 'Feb';
      case 3:
        return 'Mar';
      case 4:
        return 'Apr';
      case 5:
        return 'May';
      case 6:
        return 'Jun';
      case 7:
        return 'Jul';
      case 8:
        return 'Aug';
      case 9:
        return 'Sep';
      case 10:
        return 'Oct';
      case 11:
        return 'Nov';
      case 12:
        return 'Dec';
    }
  }

  export function formatDate(dateFromAPI, time = 'n') {

    const d = new Date(dateFromAPI);
  
    let daynw;
    if (parseInt(d.getDate()) < 10) {
      daynw = '0' + d.getDate();
    } else {
      daynw = d.getDate();
    }
    let newT =
      daynw + '-' + getMonthName(d.getMonth() + 1) + '-' + d.getFullYear();

    // if (time == 'y')
    //   newT =
    //     newT +
    //     ', ' +
    //     d.toLocaleTimeString('en-US', {
    //       hour: '2-digit',
    //       minute: '2-digit',
    //       hour12: false,
    //     });

  
    //return newT;
    const isoDate = dateFromAPI;
    const date = new Date(isoDate); // Extract parts of the date
    const day = date.getUTCDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', {month: 'short', timeZone: 'UTC'});
    const year = date.getUTCFullYear();
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes().toString().padStart(2, '0'); // Convert to 12-hour format
    const hour12 = hours % 12 || 12;
    const ampm = hours < 12 ? 'AM' : 'PM'; // Combine into formatted string
    let formattedDate = newT;
    if (time == 'y') {
      formattedDate = `${day}-${month}-${year}, ${hour12}:${minutes} ${ampm}`;
    }

    return formattedDate;
  }

  // export function validateEmail(num, setErr, setVal) {
  //   let contactPetrn = new RegExp(
  //     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  //   );
  //   if (contactPetrn.test(num)) {
  //     return true;
  //   }
  //   setErr('Invalid email');
  //   setVal('');
  //   return false;
  // }
export async function logoutHandler(navigate) {
    try {
      if (typeof window !== 'undefined') {
        document.body.classList.remove('drawer-open'); 
      }
      store.dispatch(addShowPoints({ showPoints: false }));
      navigate('/signin', { replace: true });
    } catch (error) {
      console.error('Logout Error:');
    }
  }

  export function mobileHandler(no, setFunc) {
    let regPattern = new RegExp(/^[0-9]{0,10}$/);
    if (regPattern.test(no)) {
      setFunc(no);
    }
  }

  export function darkenHexColor(hex, amount = 100) {
    // Ensure the hex color is valid
    if (!/^#[0-9A-F]{6}$/i.test(hex)) {
      throw new Error('Invalid hex color');
    }
  
    // Remove the '#' and parse the hex color
    hex = hex.substring(1);
    let rgb = parseInt(hex, 16);
  
    // Extract RGB components
    let r = (rgb >> 16) & 0xff;
    let g = (rgb >> 8) & 0xff;
    let b = (rgb >> 0) & 0xff;
  
    // Darken each component
    r = Math.max(0, r - amount);
    g = Math.max(0, g - amount);
    b = Math.max(0, b - amount);
  
    // Combine back to hex
    return `#${((1 << 24) | (r << 16) | (g << 8) | b)
      .toString(16)
      .slice(1)
      .toUpperCase()}`;
  }

  export const getTierColor = type => {
    switch (type) {
      case 'gold':
        return '#FFD700';
      case 'bronze':
        return '#CD7F32';
      case 'silver':
        return '#C0C0C0';
      case 'platinum':
        return '#E5E4E2';
    }
  };

  export const getColor = type => {
    switch (type) {
      case 'approved_count':
        return '#FFE5B1';
      case 'total_contractors_count':
        return '#FEC3D5';
      case 'super_active_contractors_count':
        return '#E6CEFF';
      case 'active_contractors_count':
        return '#D6FFF2';
      case 'dormant_contractors_count':
        return '#FCD9CA';
      case 'inactive_contractors_count':
        return '#FFE4E6';
      case 'stagnant_contractors_count':
        return '#FFF4E0';
      case 'deactivated_contractors_count':
        return '#F0C9CA';
      case 'dealer_Total_Sale_Target':
        return '#FCD9CA';
      case 'dealer_Total_Volume':
        return '#b1d0fc';
      case 'member_Contractor_Count':
        return '#D6FFF2';
      case 'achieved_Target':
        return '#E6CEFF';
      case 'Volume':
        return '#D6FFF2';
      case 'Productivity':
        return '#FFB595';
      case 'Target':
        return '#FFE5B1';
      case 'pending':
        return '#FFF4E0';
      case 'accepted':
        return '#D6FFF2';
      case 'rejected':
        return '#FFE4E6';
      case 'Contractor':
        return '#b1d0fc';
    }
  };

  export const getIcon = type => {
    switch (type) {
      case 'approved_count':
        return 'calendar';
        // return `${serverAssets}/calendar`;
      case 'total_contractors_count':
        return `${serverAssets}/contractorcount.png`;
      case 'super_active_contractors_count':
        return `${serverAssets}/superActive.png`;
      case 'active_contractors_count':
        return `${serverAssets}/active.png`;
      case 'dormant_contractors_count':
        return '#FCD9CA';
      case 'inactive_contractors_count':
        return '#FFE4E6';
      case 'deactivated_contractors_count':
        return '#F0C9CA';
      case 'Contractor':
        return 'user-plus';
      case 'Volume':
        return `${serverAssets}/volume.png`;
      case 'Productivity':
        return 'trending-up';
        // return `${serverAssets}/trending-up.png`;
      case 'Target':
        return 'percent';
      case 'pending':
        return '#FFF4E0';
      case 'approved':
        return '#D6FFF2';
      case 'rejected':
        return '#FFE4E6';
    }
  };

  export function formatNumber(num=0) {
    if (num >= 1e7) {
      return (num / 1e7).toFixed(2) + ' Cr';
    } else if (num >= 1e5) {
      return (num / 1e5).toFixed(2) + ' L';
    } else if (num >= 1e3) {
      return (num / 1e3).toFixed(2) + ' K';
    } else {
      return num?.toString();
    }
  }

  // export const fetchPdf = async (path) => {

  //   const pd=path;
  //   const pdfUrl = pd;
  //   const response = await RNFetchBlob.config({
  //     fileCache: true,
  //   }).fetch('GET', pdfUrl);
  //   const fetchedPdfPath = response.path();
  //   return fetchedPdfPath
  // };

  export const fetchPdf = async (path) => {
    const pdfUrl = path;
  
    try {
      const response = await fetch(pdfUrl);
      if (!response.ok) throw new Error('Network response was not ok');
  
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
  
      return blobUrl; 
    } catch (error) {
      console.error('Error fetching PDF:');
      return null;
    }
  };

  export const sanitizeInput = (input) => {
      
      return DOMPurify.sanitize(input, { 
        ALLOWED_TAGS: [],       
        ALLOWED_ATTR: [],
        KEEP_CONTENT: true       
      });
    };
  